import * as tslib_1 from "tslib";
import React from 'react';
export var BoxContext = React.createContext(undefined);
/** 数据中心 */
var Source = /** @class */ (function (_super) {
    tslib_1.__extends(Source, _super);
    function Source() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** 注入控制器 */
    Source.connect = function (name) {
        if (name === void 0) { name = 'controller'; }
        return function (Dummy) {
            var _a;
            return _a = /** @class */ (function (_super) {
                    tslib_1.__extends(class_1, _super);
                    function class_1() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    class_1.prototype.render = function () {
                        var ex = {};
                        ex[name] = this.context;
                        return React.createElement(Dummy, tslib_1.__assign({}, this.props, ex));
                    };
                    return class_1;
                }(React.Component)),
                _a.contextType = BoxContext,
                _a;
        };
    };
    Source.prototype.render = function () {
        return (React.createElement(BoxContext.Provider, { value: this.props.box }, this.props.children));
    };
    return Source;
}(React.Component));
export default Source;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-react-box/dir/Source/index.js
// module id = 1818
// module chunks = 0